import { render, staticRenderFns } from "./OriginCreate.vue?vue&type=template&id=a3c1fb24&"
import script from "./OriginCreate.vue?vue&type=script&lang=js&"
export * from "./OriginCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports